import { HttpClient, HttpErrorResponse, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from 'ngx-auth';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { TokenStorage } from './token-storage.service';
import { environment } from 'src/environments/environment';
import { LoginDTO, SignupDTO } from './dto/login.dto';
import { Router } from '@angular/router';
import { ApiService } from '../services/api.service';
import { Store } from '@ngrx/store';
import { CurrentProfileActions } from '../store/_features/profile/profile.actions';



interface AccessData {
  accessToken: string;
}

@Injectable()
export class AuthenticationService implements AuthService {
  private interruptedUrl: string;

  constructor(
    private api: ApiService,
    private http: HttpClient,
    private tokenStorage: TokenStorage,
    private router: Router,
    private store: Store
  ) { }

  isAuthorized() {
    return this.getAccessToken().pipe(map(token => !!token));
  }

  getAccessToken() {
    const token = this.tokenStorage.getAccessToken();

    return of(token);
  }


  

  refreshToken() {
    return of(null); // Return an Observable with no value
  }

  refreshShouldHappen(response: HttpErrorResponse) {
    return response.status === 401;
  }

  verifyRefreshToken(req: HttpRequest<any>) {
    return req.url.endsWith('/refresh');
  }

  login(loginData: LoginDTO): Observable<any> {
    return this.api.login(loginData)
      .pipe(tap((tokens: AccessData) => this.saveAccessData(tokens)));
      
    // return this.http.post<AccessData>(`${environment.apiUrl}/auth/login`, loginData)
    //   .pipe(tap((tokens: AccessData) => this.saveAccessData(tokens)));
  }

  signUp(signupData: SignupDTO): Observable<any> {
    return this.api.register(signupData)
      .pipe(tap((tokens: AccessData) => this.saveAccessData(tokens)));
    // return this.http.post<AccessData>(`${environment.apiUrl}/auth/signup`, signupData)
    //   .pipe(tap((tokens: AccessData) => this.saveAccessData(tokens)));
  }

  logout(): void {
    this.tokenStorage.clear();
    this.router.navigate(['auth','login'])
    // location.reload();
  }

  private saveAccessData({ accessToken }: AccessData) {
    this.tokenStorage.setAccessToken(accessToken);
    // this.tokenStorage.setRefreshToken(refreshToken);
  }

  getInterruptedUrl() {
    return this.interruptedUrl;
  }

  setInterruptedUrl(url: string) {
    this.interruptedUrl = url;
  }
}
